module.exports = __webpack_public_path__ + "img/contact_section_back.2eb3a9aa.jpg";